<template>
  <ranking-entry
    :streamer="result.Streamer"
    :currentStatus="currentStatus"
    :rank="rank"
    :score="result.score"
    :isPrizeTarget="isPrizeTarget()"
    :showScore="event.showScore"
    :broadcastSec="event.showBroadcastTime ? result.broadcastSec : null"
  />
</template>

<script>
import RankingEntry from '@/components/RankingEntry'

export default {
  name: 'ResultCell',
  components: {
    RankingEntry,
  },
  props: {
    isFollowed: Boolean,
    result: {
      rank: Number,
      score: Number,
      Streamer: {
        description: String,
        followerCount: Number,
        likes: Number,
        nickname: String,
        iconUrl: String,
        snsProps: {
          sns_facebook_url: String,
          sns_twitter_url: String,
          sns_youtube_url: String,
        },
        vliveId: String,
      },
      streamerInfo: Object,
    },
    event: {
      eventType: Number,
      threshold: Number,
      thresholds: Array,
      scoreType: Number,
      showScore: Boolean,
    },
    overlay: Boolean,
  },
  computed: {
    currentStatus() {
      if (!this.result.streamerInfo) return null
      return this.result.streamerInfo.currentStatus
    },
    rank() {
      switch (this.event.eventType) {
        case 1: // ランキング
          return this.result.rank
        case 2: // スコア
          return 0
        case 3: // 達成ランキング
          return this.result.rank
        default:
          return 0
      }
    },
  },
  methods: {
    isPrizeTarget() {
      let max_threshold = Math.max.apply(null, this.event.thresholds)
      if (this.event.eventType == 1 || this.event.eventType == 3) {
        // ランキング or 達成ランキング
        // 達成ランキングの場合 達成していなければnormal装飾
        if (this.event.eventType == 3 && max_threshold > this.result.score) {
          return false
        }
        // ランキング形式の場合閾値より低いランクの人はnormal装飾
        if (this.event.numberOfWinners < this.result.rank) {
          return false
        }

        return true
      } else if (this.event.eventType == 2) {
        // 一定スコア以上
        if (max_threshold > this.result.score) {
          return false
        }

        return true
      }
    },
  },
}
</script>
